//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import AccDailyLedgerDownloadView from '@/views/Accounting/AccDailyLedger/AccDailyLedgerDownload'

//
export default {
    path: 'daily_ledger',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'daily-ledger-download',
            component: AccDailyLedgerDownloadView,
        },
    ],
    meta: {
        title: 'Libro diario',
    },
}
